import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RevealLines } from "@/components/Reveal";
import { CONTACT } from "@/data/site";

export const SectionCTA = () => (
  <section className="container-rossi py-24 grid lg:grid-cols-12 gap-10 border-t border-rossi-cream/15" data-testid="section-cta">
    <div className="lg:col-span-7">
      <p className="eyebrow mb-6">Begin</p>
      <RevealLines className="font-serif text-4xl sm:text-5xl text-rossi-cream leading-[1.05]" lines={["Designed by you."]} />
      <RevealLines as="p" className="gold-text text-4xl sm:text-5xl leading-[1.1]" lines={["Built by Rossi."]} delay={0.2} />
    </div>
    <div className="lg:col-span-4 lg:col-start-9 flex flex-col justify-end border-l border-rossi-cream/15 pl-6">
      <p className="text-rossi-cream/70 leading-relaxed">Sketch your room in The Studio, then book Vincent for a free survey and a fixed, itemised quote.</p>
      <div className="mt-6 flex flex-col gap-2">
        <Link to="/studio" data-testid="cta-ai-studio" className="btn-gold justify-between">Enter The Studio <ArrowUpRight size={15} /></Link>
        <Link to="/booking" data-testid="cta-book" className="btn-ghost-gold justify-between">Book a consultation <ArrowUpRight size={15} /></Link>
        <a href={CONTACT.phoneHref} data-testid="cta-call" className="btn-ghost-gold justify-between">Call {CONTACT.phone} <ArrowUpRight size={15} /></a>
      </div>
    </div>
  </section>
);

export default SectionCTA;
